<template>
    <div>
        <FormHeading>Where is your property located?</FormHeading>
        <div class="location-container">
            <div
                class="location-item"
                v-for="(location, index) in locations"
                :key="index"
                @click="next(location)"
                :class="{ disabled: location.disabled }"
            >
                <div class="location-img">
                    <img :src="location.src" :alt="location.state" />
                </div>
                <p class="location-label">{{ location.state }}</p>
                <label v-if="location.disabled">Coming Soon</label>
            </div>
        </div>
        <div class="button-group">
            <Link to="/home">
                <Button class="transparent">Back</Button>
            </Link>
        </div>
    </div>
</template>

<script>
import { FormHeading, Button, Link } from "../../style";
import { PROPERTY_LOCATIONS } from "../../utils/constants";
import { scrollTop } from "../../utils";

export default {
  name: "PropertyLocation",
  props: {
    step: {
      type: Number,
      required: true
    },
    properties: {
      type: Array,
      default: () => []
    },
    property: {
      type: Number,
      default: 1
    }
  },
  components: {
    FormHeading,
    Button,
    Link
  },
  computed: {
    locations() {
      return PROPERTY_LOCATIONS;
    }
  },
  mounted() {
    scrollTop();
  },
  methods: {
    next(location) {
      if (!location.disabled) {
        const { abbrev } = location;
        this.$emit("format-property", abbrev);
        this.$emit("next-step");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
h2 {
    margin: 0 0 30px;
}
.location-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: auto;
    @media (max-width: 1024px) {
        display: grid;
        grid-gap: $padding-lg;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: repeat(4, 200px);
    }
    @media (max-width: $mobile-hd-width) {
        grid-template-columns: 1fr;
    }
}
.location-item {
    background-color: #f5f5f5;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: calc((100% / 4) - 30px);
    height: 200px;
    @include breakpoint(tablet-hd-width) {
        margin: 15px;
    }
    &:hover {
        background-color: $background-gray;
    }
    &.disabled {
        cursor: not-allowed;
        .location-img {
            opacity: 0.5;
        }
    }

    @media (max-width: 1024px) {
        width: inherit;
    }
}
.location-img {
    min-height: 100px;
    display: flex;
    align-items: center;
}
.location-label {
    margin: $padding-md auto 0;
    font-size: $font-size-sm;
}

.button-group {
    width: 100%;
    display: flex;
    margin-top: $padding-lg;
    a {
        text-decoration: none;
    }
}
.disabled {
    cursor: default;
    &:hover {
        background-color: #f5f5f5;
    }
}
</style>
